import { render, staticRenderFns } from "./NormalSearchNav507.vue?vue&type=template&id=206914a2&scoped=true"
import script from "./NormalSearchNav507.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav507.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206914a2",
  null
  
)

export default component.exports